import { useEffect, useRef } from "react";
import { track, type AnalyticsEvents } from "@/lib/analytics";

type EventName = keyof AnalyticsEvents;

/**
 * Track an analytics event once per unique `key` per component mount lifecycle.
 * Safe for React Strict Mode (dedupes double-fires).
 * Re-fires if `key` changes (e.g. navigating to a different place).
 */
export function useTrackOnce<E extends EventName>(
  event: E,
  props: AnalyticsEvents[E],
  key: string | null | undefined,
) {
  const tracked = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!key) return;
    if (tracked.current.has(key)) return;
    tracked.current.add(key);
    track(event, props);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
}
